<!-- 换表记录页面 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
    
  <a-card :bordered="false" class="new-table-card">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('新表编号')">
              <j-input :placeholder="$t('新表编号模糊查询')" v-model="queryParam.meterIdNew"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('旧表编号')">
              <j-input :placeholder="$t('旧表编号模糊查询')" v-model="queryParam.meterId"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('换表原因类型')">
                <!-- <j-dict-select-tag v-model="queryParam.meterChangeType" placeholder="请输入换表原因类型" dictCode="meterChangeType" /> -->
                <a-cascader
                  v-model="meterChangeType"
                  :options="options"
                  expand-trigger="hover"
                  :placeholder="$t('请选择换表原因类型')"
                  changeOnSelect
                  @change="onChange"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="12" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('查询起止时间')">
                <a-range-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                  @change="onDateRangeChange"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset1" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('换表记录'))">{{ $t('导出') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x: 'max-content'}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
        <div slot="filterDropdown">
          <a-card>
            <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
              <a-row>
                <template v-for="item in defColumns">
                  <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                    <a-col :span="12" :key="item.key">
                      <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                    </a-col>
                  </template>
                </template>
              </a-row>
            </a-checkbox-group>
          </a-card>
        </div>
        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
        
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <mete-change-meter-record-modal ref="modalForm" @ok="modalFormOk"></mete-change-meter-record-modal>
  </a-card>
  </a-col>
</a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import MeteChangeMeterRecordModal from './modules/MeteChangeMeterRecordModal'
  import { getAction, httpAction } from '@/api/manage'
  import moment from 'moment'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import Vue from 'vue'
  import JInput from '@/components/jeecg/JInput'
  import TableDragResize  from '@/mixins/TableDragResize'
  export default {
    name: 'MeteChangeMeterRecordList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeteChangeMeterRecordModal,
      JInput
    },
    data () {
      return {
        description: 'mete_change_meter_record管理页面',
        collapsed: false,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meteChangeMeterRecord/list",
          delete: "/jeecg-charge/meter/meteChangeMeterRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meteChangeMeterRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meteChangeMeterRecord/exportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meteChangeMeterRecord/importExcel",
        },
        beginDate: null,
        endDate: null,
        endOpen: false,
        date:[],
        meterChangeType:[]
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width: 200,
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width: 200,

          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width: 200,
            ellipsis: true
          },{
            title: this.$t('旧表编号'),
            align:"center",
            dataIndex: 'meterIdOld',
            width: 200,
          },{
            title: this.$t('新表编号'),
            align:"center",
            dataIndex: 'meterIdNew',
            width: 200,
          },{
            title: this.$t('旧表结算流量(m³)'),
            align:"center",
            dataIndex: 'meterOldSumFlowAfterChange',
            width: 200,
          },{
            title: this.$t('新表起始读数(m³)'),
            align:"center",
            dataIndex: 'meterStartNum',
            width: 200,
          },{
            title: this.$t('旧表机械读数(m³)'),
            align:"center",
            dataIndex: 'meterOldMachineReadingNum',
            width: 200,
          },{
            title: this.$t('换表原因'),
            align:"center",
            dataIndex: 'meterChangeType',
            customRender: (text) => {
              //字典值替换通用方法
              // return filterDictTextByCache('meterChangeType', text);
              return this.meterChangeTypeList[text]
            },
            width: 200,
          },{
            title: this.$t('换表结算余额(元)'),
            align:"center",
            dataIndex: 'meterUserAccountNumAfterChange',
            width: 200,
          },{
            title: this.$t('操作时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 200,
          },{
            title: this.$t('操作人'),
            align:"center",
            dataIndex: 'createBy',
            width: 200,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:60,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      // i18n：换表原因字典（选项值映射的值走 this.$t）
      meterChangeTypeList() {
        return {
          0: this.$t('周期性换表'),
          1: this.$t('故障换表'),
          2: this.$t('故障换表/基表问题'),
          3: this.$t('故障换表/基表问题/计量问题'),
          4: this.$t('故障换表/基表问题/阀门故障'),
          5: this.$t('故障换表/基表问题/基表爆裂'),
          6: this.$t('故障换表/电子问题'),
          7: this.$t('故障换表/电子问题/不上传数据'),
          8: this.$t('故障换表/电子问题/水表无反应(黑屏、无法激活)'),
          9: this.$t('故障换表/磁干扰'),
          10: this.$t('故障换表/缺电'),
          11: this.$t('故障换表/其他')
        }
      },
      // i18n：级联选项使用 computed 以响应语言切换
      options() {
        return [
          {
            value: '0',
            label: this.$t('周期性换表')
          },
          {
            value: '1',
            label: this.$t('故障换表'),
            children: [
              {
                value: '2',
                label: this.$t('基表问题'),
                children: [
                  {
                    value: '3',
                    label: this.$t('计量问题')
                  },
                  {
                    value: '4',
                    label: this.$t('阀门故障')
                  },
                  {
                    value: '5',
                    label: this.$t('基表爆裂')
                  }
                ]
              },
              {
                value: '6',
                label: this.$t('电子问题'),
                children: [
                  {
                    value: '7',
                    label: this.$t('不上传数据')
                  },
                  {
                    value: '8',
                    label: this.$t('水表无反应（黑屏，无法激活）')
                  }
                ]
              },
              {
                value: '9',
                label: this.$t('磁干扰')
              },
              {
                value: '10',
                label: this.$t('缺电')
              },
              {
                value: '11',
                label: this.$t('其他')
              }
            ]
          }
        ]
      }
    },
    methods: {
      onOk(value) {
        console.log('onOk: ', value);
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      onChange(value) {
        // value 是级联选择器的完整路径数组，如 ["1", "2", "3"]
        if (value && value.length > 0) {
          // 获取最后一层的值
          const lastValue = value[value.length - 1]
          // 存储到 formReason 字段
          this.$set(this.queryParam, 'meterChangeType', lastValue);
        }
      },
      searchReset1(){
        this.meterChangeType = [];
        this.searchReset();
      }
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }

</style>